<div #scrollElement class="pw-content-wrapper" (scroll)="onScroll($event)">
  <main>
    <ng-content></ng-content>
  </main>
</div>
